import type { MaturityAreaKey, MaturityItemId, MaturityLevelKey } from '@cobliteam/hooks/src/useBasicValueMaturity/basicValueMaturityModel';
import {
  BellRing,
  Boxes,
  Cable,
  ClipboardCheck,
  Gauge,
  Link2,
  type LucideIcon,
  MapPin,
  Rocket,
  Router,
  ShieldCheck,
  SlidersHorizontal,
  Truck,
  UserPlus,
  Users,
  Wrench,
} from 'lucide-react';

/**
 * Presentation-only mapping (icons) for the maturity model. Kept in the app layer so the shared
 * `@cobliteam/hooks` model stays free of JSX / lucide. Copy lives in i18n, keyed by the same ids.
 */
export const AREA_ICON: Record<MaturityAreaKey, LucideIcon> = {
  installation: Wrench,
  setup: Users,
  configuration: SlidersHorizontal,
};

export const LEVEL_ICON: Record<MaturityLevelKey, LucideIcon> = {
  connected: Cable,
  organized: Users,
  monitored: ShieldCheck,
  optimized: MapPin,
  turbocharged: Rocket,
};

export const ITEM_ICON: Record<MaturityItemId, LucideIcon> = {
  devices: Router,
  vehicles: Truck,
  'device-association': Cable,
  drivers: Users,
  'driver-association': Link2,
  users: UserPlus,
  groups: Boxes,
  alerts: BellRing,
  speed: Gauge,
  geofences: MapPin,
  checklists: ClipboardCheck,
};
